import { useEffect } from "react"
import Header from "../../components/header/header"
import Footer from "../../components/footer/footer"
import SearchModel from "../../components/search_model/search"
import { customScript } from "../../common/customscript"
import Blog from "../../components/blog/blog"

const Blogs = () => {
    useEffect(() => {
        customScript()
    }, [])

    return (
        <>
            <Header />
            <Blog />
            <Footer />
            <SearchModel />
        </>
    )
}

export default Blogs